import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AppState } from 'src/app/@store/app.reducers';
import { ConsultaSiniestroOutput, TerceroComplemento } from 'src/app/models/complementos-web/complementos-web.model';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { selectDetalleSiniestroSiniestros, selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { AltaTipoTercerosComponent } from '../alta-tipo-terceros/alta-tipo-terceros.component';
import { NgClass, SlicePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';

@Component({
    selector: 'app-crear-actualizar-terceros',
    templateUrl: './crear-actualizar-terceros.component.html',
    styleUrls: ['./crear-actualizar-terceros.component.scss'],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, AltaTipoTercerosComponent, SlicePipe]
})
export class CrearActualizarTercerosComponent implements AfterViewInit, OnDestroy {

  @ViewChild('terceros') paginator: MatPaginator;
  @ViewChild('altaTerceros') refAltaTerceros: AltaTipoTercerosComponent;

  @Input() public modulo: string;
  @Input() public datosTerceros: MatTableDataSource<any> = new MatTableDataSource([]);

  @Output() eventosTerceros = new EventEmitter<{ nombre: string, valor: any }>();

  public tamanoResultadosTerceros: number = 0;
  public selectCoberturasDatosTerceros = null;
  public selectedCoberturaRowIndexTerceros: number = null;

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };

  public habilitaTercero: boolean = false;
  public terceroConsulta: any = null;

  public displayColumns = ['Tipo', 'Tercero', 'Estatus', 'Compañia', 'Placas', 'Acciones'];
  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public listaObservables = new Subscription();

  constructor(
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComplementService: ProcesosComunesComplementoService
  ) {
    this.obtenerRedux();
  }

  ngAfterViewInit(): void {

    if (['Lesionados', 'R&P', 'Servicios'].includes(this.modulo)) {
      this.displayColumns = this.displayColumns.filter(cols => cols != "Acciones");
    }
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerRedux() {
    const subsRedux = combineLatest([
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null))
    ]).subscribe(([detalleCompleto, detalleBase]) => {
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;
      this.consultaTerceros();
    });
    this.listaObservables.add(subsRedux);
  }

  abrirSeccionTerceros(tercero?) {
    this.habilitaTercero = true;
    this.terceroConsulta = tercero;
  }

  regresaConsulta() {
    this.habilitaTercero = false;
    this.terceroConsulta = null;
    this.consultaTerceros();
  }

  procesaEventosTercero(evento: { nombre: string, valor: any }) {
    if (evento.nombre == 'ACTUALIZAR_COMPLEMENTO') {
      this.regresaConsulta();
    }
  }

  eliminarTercero(tercero: TerceroComplemento) {
    const siniestroFormateado = this.procesosComplementService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    let serieNormal = ((this.detalleSiniestroCompleto.Siniestro[0].serie_normal == null) ? 0 : this.detalleSiniestroCompleto.Siniestro[0].serie_normal);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      id_tercero: tercero?.id_tercero,
      estatus: 1
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.eliminaTercero(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null) {
          this.procesosComplementService.alertaGeneralComplemento('Eliminado', `La información del tercero se eliminó correctamente`, 'success', false, true);
          this.consultaTerceros();
        } else {
          this.procesosComplementService.alertaGeneralComplemento('Aviso', `${value.Mensaje || value.MensajeSistema}.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos eliminar el registro del tercero.' }));
      },
    })
  }

  consultaTerceros() {
    const siniestroFormateado = this.procesosComplementService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    let serieNormal = ((this.detalleSiniestroCompleto.Siniestro[0].serie_normal == null) ? 0 : this.detalleSiniestroCompleto.Siniestro[0].serie_normal);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tiposTercero: '',
      modulo: this.modulo ?? "",
      tipoServicio: 0
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaTerceros(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.datosTerceros = new MatTableDataSource(value.Resultado["Terceros"]);
        setTimeout(() => {
          this.datosTerceros.paginator = this.paginator;
        }, 100);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del tercero.' }));
      },
    })
  }

  seleccionarTercero(filaTercero) {
    if (this.modulo != undefined) {
      this.eventosTerceros.emit({ nombre: 'SELECCION_TERCERO', valor: filaTercero });
    }
  }

  validaEliminacion(asegurado: TerceroComplemento) {
    this.procesosComplementService.alertaGeneralComplemento(
      'Aviso!',
      '¿Está seguro que desea eliminar el registro?.',
      'question',
      true,
      true
    ).then(result => {
      if (result.isConfirmed) {
        this.eliminarTercero(asegurado);
      }
    });
  }
}
